import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvSeries';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 tracking-wide">
                红桃影院
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              红桃影视为您汇聚电视剧全集免费资源，最新电视剧、热播剧集同步更新，国产剧全集、韩剧在线看一网打尽。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base font-heading font-semibold text-background-50 mb-4">剧集分类</h3>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-heading font-semibold text-background-50 mb-4">快速链接</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/hot" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热播推荐</Link>
              </li>
              <li>
                <Link to="/category/new" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">最新上线</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-heading font-semibold text-background-50 mb-4">联系方式</h3>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                <span>contact@hongtao.tv</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line mt-0.5 text-foreground-500"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                <span>北京市朝阳区影视产业园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} 红桃影院 | 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}